import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectVehicles = createFeatureSelector<any>('vehicles');

export const selectVehiclesState = createSelector(
    selectVehicles,
    (state: any) => state,
);
